import { InfoBarHostViewState } from '../schema/InfoBarMessageViewState';
import { infoBarMessageCreatorsMap } from '../utils/infoBarMessageCreatorsMap';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import { action } from 'satcheljs/lib/legacy';

/**
 * @param viewState the host viewstate storing the list of messageIds to render
 * @param messageId the message Id of the infobar to remove
 * @param key if the message was added with a key, the message is stored in a bucket with that key (e.g. itemId, or composeId)
 */
const addInfoBarMessage = action('addInfoBarMessage')(function addInfoBarMessage(
    viewState: InfoBarHostViewState,
    messageId: string,
    key: string = '0',
    infoBarMessageViewStateCreator?: InfoBarMessageViewStateCreator
) {
    if (viewState.infoBarIds.indexOf(messageId) == -1) {
        viewState.infoBarIds.push(messageId);
    } else {
        // clone infoBarIds to force re-render
        viewState.infoBarIds = [...viewState.infoBarIds];
    }

    if (infoBarMessageViewStateCreator) {
        if (!infoBarMessageCreatorsMap[key]) {
            infoBarMessageCreatorsMap[key] = {};
        }
        infoBarMessageCreatorsMap[key][messageId] = infoBarMessageViewStateCreator;
    }
});

export default addInfoBarMessage;
